<template>
  <div class="modal fade" id="MarcheModal" data-bs-backdrop="static" data-bs-keyboard="false" tabindex="-1"
    aria-hidden="true" ref="MarcheModalRef">
    <div class="modal-dialog">
      <div class="modal-content">
        <div class="modal-header">
          <h1 class="modal-title fs-5">{{ selectedItem ? 'Modifier' : 'Ajouter' }} un marché</h1>
          <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
        </div>
        <div class="modal-body">
          <Form ref="marcheForm" @submit="soumettre" :validation-schema="marcheSchema">
            <div class="row">
              <div class="col-md-6 col-sm-12">
                <div class="form-group">
                  <label class="d-block text-black fw-semibold">Nom du marché <span class="text-danger">*</span></label>
                  <Field name="nomMarche" v-model="nomMarche" type="text" class="form-control shadow-none fs-md-15 text-black"
                    placeholder="Entrer le nom du marché" />
                  <ErrorMessage name="nomMarche" class="text-danger" />
                </div>
              </div>
              <div class="col-md-6 col-sm-12">
                <div class="form-group">
                  <label class="d-block text-black fw-semibold">Code <span class="text-danger"></span></label>
                  <Field name="codeMarche" v-model="codeMarche" type="text" class="form-control shadow-none fs-md-15 text-black"
                    placeholder="Entrer le code" />
                  <ErrorMessage name="codeMarche" class="text-danger" />
                </div>
              </div>
            </div>
            <div class="row mt-5">
              <div class="col-md-3 text-md-end text-xl-end text-sm-center col-sm-12">
                <button type="submit" class="btn btn-primary w-100">{{ selectedItem ? 'Modifier' : 'Enregistrer' }}</button>
              </div>
            </div>
          </Form>
        </div>
        <div class="modal-footer">
          <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">Fermer</button>
        </div>
      </div>
    </div>
  </div>
</template>
<script lang="ts">
import { defineComponent, ref, watch } from "vue";
import { Form, Field, ErrorMessage } from "vee-validate";
import { hideModal, success, error } from "@/utils/utils";
import * as Yup from "yup";
import axios, { AxiosError } from "axios";

export default defineComponent({
  name: "MarcheModal",
  components: { Form, Field, ErrorMessage },
  props: { item: { type: [String, Number, null], default: null } },
  setup: (props, { emit }) => {
    const marcheSchema = Yup.object().shape({
      nomMarche: Yup.string().required("Le nom du marché est obligatoire"),
      codeMarche: Yup.string().notRequired(),
    });
    const marcheForm = ref<any | null>(null);
    const nomMarche = ref("");
    const codeMarche = ref("");
    const selectedItem = ref<any>(null);
    const MarcheModalRef = ref<null | HTMLElement>(null);

    const resetForm = () => {
      nomMarche.value = "";
      codeMarche.value = "";
      selectedItem.value = null;
    };

    const getMarche = async (id: number | string) => {
      try {
        const response = await axios.get(`marche/${id}`);
        if (response.data && response.data.data) {
          const data = response.data.data;
          nomMarche.value = data.nomMarche || "";
          codeMarche.value = data.codeMarche || "";
        }
        error("Route de récupération non encore implémentée au backend");
      } catch (err) {
        error(err instanceof Error ? err.message : String(err));
      }
    };

    watch(() => props.item, async (newValue) => {
      if (newValue !== null && newValue !== undefined) {
        await getMarche(newValue);
      } else {
        resetForm();
      }
    }, { immediate: true });

    const soumettre = async (values, { resetForm }) => {
      try {
        // TODO: Ajouter routes POST/PUT au backend
        if (selectedItem.value && selectedItem.value.id) {
          error("Route de modification non encore implémentée au backend");
        } else {

          const response = await axios.post("marche", values);
          if (response.data && response.data.data) {
            success("Le marché a été enregistré avec succès");
            resetForm();
            hideModal(MarcheModalRef.value);
            emit("close");
          }
          else {
            error("Une erreur est survenue");
          }
        }
      } catch (err) {
        error(err instanceof AxiosError ? err.response?.data?.message || "Une erreur est survenue" : "Une erreur est survenue");
      }
    };

    return { nomMarche, codeMarche, selectedItem, MarcheModalRef, soumettre, marcheSchema, marcheForm };
  },
});
</script>

